import Vue from 'vue'
import CxExplorateurFichier from '@/wikaz-core/ui/composants/fichiers/CxExplorateurFichier'
Vue.component('cx-explorateur-fichier', CxExplorateurFichier)